// extracted by mini-css-extract-plugin
export default {"labelInput":"style_labelInput__kIOn7","labelFormat":"style_labelFormat__MVNGz","InputFormat":"style_InputFormat__uFp3c","inputboxFormat":"style_inputboxFormat__RToaA"};